// extracted by mini-css-extract-plugin
export default {"modalOverlay":"HC-z","modalContent":"IC-z","header":"JC-z","close":"KC-z"};